"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileOps = void 0;
const url_search_params_1 = __importDefault(require("@ungap/url-search-params"));
const APIErrors_1 = require("./resources/APIErrors");
const APITasks_1 = require("./resources/APITasks");
const APIAbortController_1 = require("./APIAbortController");
const FSIServerClientInterface_1 = require("./FSIServerClientInterface");
const FSIServerClientUtils_1 = require("./FSIServerClientUtils");
const index_1 = require("./index");
const LogLevel_1 = require("./LogLevel");
const URLSearchParams = url_search_params_1.default;
const regDirName = /[\\/?*<>"|]/;
class FileOps {
    constructor(classInit, taskController) {
        this.classInit = classInit;
        this.taskController = taskController;
        this.client = classInit.client;
        this.com = classInit.com;
        this.baseURL = this.client.getServerBaseQuery();
    }
    static isValidDirName(name) {
        return !name.match(regDirName);
    }
    static getInvalidDirNameCharacters(name) {
        let ret = "";
        const matches = name.match(regDirName);
        if (matches && typeof (matches) === "object" && matches.length > 0) {
            ret = matches[0];
        }
        return ret;
    }
    static getCopyEntryTargetPath(baseSourcePath, entry, newPath) {
        let ret;
        const pdSource = FSIServerClientUtils_1.FSIServerClientUtils.FILE_AND_PATH(entry.path);
        newPath = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_PATH(newPath);
        const subDir = FSIServerClientUtils_1.FSIServerClientUtils.GET_SUB_DIR(baseSourcePath, pdSource.path);
        const targetDir = FSIServerClientUtils_1.FSIServerClientUtils.JOIN_PATH(newPath, subDir);
        if (entry.type === "file")
            ret = targetDir + pdSource.dir;
        else
            ret = FSIServerClientUtils_1.FSIServerClientUtils.JOIN_PATH(targetDir, pdSource.dir);
        return ret;
    }
    createDirectory(path, httpOptions = {}) {
        if (APIAbortController_1.APIAbortController.IS_ABORTED(httpOptions.abortController)) {
            return this.com.getAbortPromise();
        }
        path = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_PATH(path);
        path = path.replace(/\/$/, "");
        const pathAndDir = FSIServerClientUtils_1.FSIServerClientUtils.EXTRACT_LAST_DIR(path);
        if (!FileOps.isValidDirName(pathAndDir.dir)) {
            return this.taskController.getErrorPromise(APIErrors_1.APIErrors.createDir, [path], APIErrors_1.APIErrors.invalidDirName, [FileOps.getInvalidDirNameCharacters(pathAndDir.dir)]);
        }
        const url = this.client.getServicePath('directory') + "/" + index_1.FSIServerClient.ENCODE_PATH(path);
        return this.com.putJsonBoolean(url, null, { def: APIErrors_1.APIErrors.createDir, content: [path] }, null, httpOptions);
    }
    rename(oldPath, newPath, service, copyOptions = {}) {
        if (APIAbortController_1.APIAbortController.IS_ABORTED(copyOptions.abortController)) {
            return this.com.getAbortPromise();
        }
        if (service !== "directory" && service !== "file") {
            return this.taskController.getErrorPromise(APIErrors_1.APIErrors.rename, [oldPath, newPath], APIErrors_1.APIErrors.invalidServiceName, [service]);
        }
        if (service === "file") {
            oldPath = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_FILE_PATH(oldPath);
            newPath = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_FILE_PATH(newPath);
        }
        else {
            oldPath = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_PATH(oldPath);
            newPath = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_PATH(newPath);
        }
        const pd = FSIServerClientUtils_1.FSIServerClientUtils.FILE_AND_PATH(newPath);
        if (!FileOps.isValidDirName(pd.dir)) {
            return this.taskController.getErrorPromise(APIErrors_1.APIErrors.rename, [oldPath, newPath], APIErrors_1.APIErrors.invalidNewName, [FileOps.getInvalidDirNameCharacters(pd.dir)]);
        }
        if (oldPath === newPath) {
            return FSIServerClientInterface_1.FSIServerClientInterface.GET_TRUE_PROMISE();
        }
        else {
            const url = this.client.getServicePath(service) + "/" + index_1.FSIServerClient.ENCODE_PATH(oldPath);
            const query = new URLSearchParams();
            query.set("cmd", "move");
            query.set("to", newPath);
            if (copyOptions.overwrite) {
                query.set("overwrite", "true");
            }
            return this.com.postJSONBoolean(url, query, { def: APIErrors_1.APIErrors.rename, content: [oldPath, newPath] }, null, copyOptions);
        }
    }
    move(oldPath, newPath, service) {
        return this.rename(oldPath, newPath, service);
    }
    delete(path, service, httpOptions) {
        if (APIAbortController_1.APIAbortController.IS_ABORTED(httpOptions.abortController)) {
            return this.com.getAbortPromise();
        }
        if (service === "directory") {
            path = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_PATH(path);
        }
        else {
            path = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_FILE_PATH(path);
        }
        const url = this.client.getServicePath(service) + "/" + index_1.FSIServerClient.ENCODE_PATH(path);
        const mainErrorDef = (service === "file") ? APIErrors_1.APIErrors.deleteFile : APIErrors_1.APIErrors.deleteDir;
        return this.com.deleteJsonBoolean(url, { def: mainErrorDef, content: [path] }, null, httpOptions);
    }
    reImport(path, service, image = true, metaData = true, httpOptions = {}) {
        if (APIAbortController_1.APIAbortController.IS_ABORTED(httpOptions.abortController)) {
            return this.com.getAbortPromise();
        }
        const query = new URLSearchParams();
        query.set("cmd", "reimport");
        const options = [];
        if (image)
            options.push("image");
        if (metaData)
            options.push("metadata");
        if (options.length === 0) {
            return this.taskController.getErrorPromise(APIErrors_1.APIErrors.reImportNothing);
        }
        query.set("options", options.join(","));
        const url = this.client.getServicePath(service) + "/" + index_1.FSIServerClient.ENCODE_PATH(path);
        const mainErrorDef = (service === "file") ? APIErrors_1.APIErrors.reImportFile : APIErrors_1.APIErrors.reImportDir;
        return this.com.postJSONBoolean(url, query, { def: mainErrorDef, content: [path] }, null, httpOptions);
    }
    reImportDir(path, image = true, metaData = true, httpOptions) {
        const pdSource = FSIServerClientUtils_1.FSIServerClientUtils.FILE_AND_PATH(path);
        if (pdSource.error) {
            return this.taskController.getErrorPromise(APIErrors_1.APIErrors.reImportDir, [pdSource.error]);
        }
        return this.reImport(path, "directory", image, metaData, httpOptions);
    }
    reImportFile(path, image = true, metaData = true, httpOptions) {
        const pdSource = FSIServerClientUtils_1.FSIServerClientUtils.FILE_AND_PATH(path);
        if (pdSource.error) {
            return this.taskController.getErrorPromise(APIErrors_1.APIErrors.reImportFile, [pdSource.error]);
        }
        return this.reImport(path, "file", image, metaData, httpOptions);
    }
    copyFile(path, toPath, copyOptions = {}) {
        if (APIAbortController_1.APIAbortController.IS_ABORTED(copyOptions.abortController)) {
            return this.com.getAbortPromise();
        }
        const pdSource = FSIServerClientUtils_1.FSIServerClientUtils.FILE_AND_PATH(path);
        const pdTarget = FSIServerClientUtils_1.FSIServerClientUtils.FILE_AND_PATH(toPath);
        let err;
        if (pdSource.error) {
            err = {
                content: pdSource.errorContent,
                def: pdSource.error,
            };
        }
        else if (pdTarget.error) {
            err = {
                content: pdTarget.errorContent,
                def: pdTarget.error,
            };
        }
        if (err) {
            return this.taskController.getErrorPromise(APIErrors_1.APIErrors.copyFile, [path, toPath], err.def, err.content);
        }
        const url = this.client.getServicePath("file") + "/" + index_1.FSIServerClient.ENCODE_PATH(path);
        const query = new URLSearchParams();
        query.set("cmd", "copy");
        query.set("to", toPath);
        if (copyOptions.overwrite === true) {
            query.set("overwrite", "true");
        }
        return this.com.postJSONBoolean(url, query, { def: APIErrors_1.APIErrors.copyFile, content: [path, toPath] }, null, copyOptions);
    }
    copyDirectory(path, toPath, includingDir = true, listOptions, queue) {
        if (APIAbortController_1.APIAbortController.IS_ABORTED(listOptions.abortController)) {
            return this.com.getAbortPromise();
        }
        const self = this;
        let qPrg;
        if (queue) {
            qPrg = queue.getProgressData();
        }
        path = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_PATH(path);
        toPath = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_PATH(toPath);
        const mainTask = this.taskController.setCurrentTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.copyDir, [path, toPath]);
        if (qPrg && queue) {
            qPrg.currentTask = mainTask;
            qPrg.task.length = 2;
            queue.onProgress(qPrg);
        }
        const ret = new Promise((resolve, reject) => {
            const pdPath = FSIServerClientUtils_1.FSIServerClientUtils.EXTRACT_LAST_DIR(path);
            const pathAndDirTarget = FSIServerClientUtils_1.FSIServerClientUtils.EXTRACT_LAST_DIR(toPath);
            if (!FileOps.isValidDirName(pathAndDirTarget.dir) || pathAndDirTarget.dir.length < 1 || pathAndDirTarget.path.length < 2) {
                return reject(self.com.err.get(APIErrors_1.APIErrors.copyDir, [path, toPath], APIErrors_1.APIErrors.invalidTargetPath));
            }
            if (includingDir) {
                toPath = FSIServerClientUtils_1.FSIServerClientUtils.NORMALIZE_PATH(toPath + pdPath.dir);
            }
            const promise = self.client.createDirectory(toPath, { overwrite: true, abortController: listOptions.abortController }, self.taskController);
            promise.then(() => {
                const listPromise = self.client.listServer(path, listOptions);
                listPromise.then(body => {
                    return body;
                })
                    .then(ld => {
                    APIAbortController_1.APIAbortController.THROW_IF_ABORTED(listOptions.abortController);
                    const entries = ld.entries;
                    if (qPrg && queue) {
                        qPrg.task.length = entries.length + 2;
                        qPrg.task.pos = 2;
                    }
                    const nLast = entries.length - 1;
                    for (let i = 0, p = Promise.resolve(true); i < entries.length; i++) {
                        APIAbortController_1.APIAbortController.THROW_IF_ABORTED(listOptions.abortController);
                        p = p.then(() => new Promise((resolveInner) => {
                            APIAbortController_1.APIAbortController.THROW_IF_ABORTED(listOptions.abortController);
                            const entry = entries[i];
                            const targetPath = FileOps.getCopyEntryTargetPath(path, entry, toPath);
                            if (entries[i].type === "file") {
                                self.taskController.setCurrentSubTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.copyFile, [entries[i].path, targetPath]);
                            }
                            else {
                                self.taskController.setCurrentSubTask(LogLevel_1.LogLevel.debug, APITasks_1.APITasks.createDir, [targetPath]);
                            }
                            if (qPrg && queue) {
                                qPrg.task.pos = 2 + i;
                                qPrg.currentTask = self.taskController.getCurrentTask();
                                queue.onProgress(qPrg);
                            }
                            self.copyEntry(entry, targetPath, listOptions)
                                .then(() => {
                                resolveInner(true);
                                if (i === nLast) {
                                    self.taskController.resetSubTask();
                                    resolve(true);
                                }
                            })
                                .catch(err => {
                                reject(err);
                            });
                        }));
                    }
                })
                    .catch(err => {
                    return reject(err);
                });
            })
                .catch(err => {
                return reject(err);
            });
        });
        if (qPrg) {
            qPrg.currentTask = this.taskController.getCurrentTask();
        }
        return ret;
    }
    copyEntry(entry, targetPath, listOptions) {
        if (APIAbortController_1.APIAbortController.IS_ABORTED(listOptions.abortController)) {
            return this.com.getAbortPromise();
        }
        if (entry.type === "file") {
            return this.copyFile(entry.path, targetPath, listOptions);
        }
        else {
            return this.createDirectory(targetPath, listOptions);
        }
    }
}
exports.FileOps = FileOps;
